import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  mobile: defineAsyncComponent(() => import("/app/layouts/mobile.vue").then(m => m.default || m))
}